import { createStore } from '@store/createStore';

import { mapConfig } from '../constants/mapConfig';

const initialGeoState = {
  geoUrl: mapConfig.world.geoUrl,
  center: mapConfig.world.center,
  scale: mapConfig.world.scale,
  geoUnit: {},
};

const useMapStore = createStore(
  (set) => ({
    data: { allowedAreas: {}, continents: {}, tabsSortedArr: [], legend: {}, facility: [] },
    tooltipContentStatic: null,
    openTab: '',
    openLegend: true,
    geoState: initialGeoState,

    actions: {
      setMapData: (data) => set({ data }),
      setMapTooltipContentStatic: (tooltipContentStatic) => set({ tooltipContentStatic }),
      setMapOpenTab: (openTab) => set({ openTab }),
      setMapOpenLegend: (openLegend) => set({ openLegend }),
      setMapGeoStateInitial: () => set({ geoState: initialGeoState }),
      setMapGeoState: ({ type, name, facilityName, country }) => {
        if (type == 'continent') {
          const { geoUrl, center, scale } = mapConfig.continents[name] || {};
          geoUrl && set({ geoState: { geoUrl, center, scale, geoUnit: { type, name, facilityName } } });
        }

        if (type == 'country') {
          const { geoUrl, center, scale } = mapConfig.countries[name] || {};
          geoUrl && set({ geoState: { geoUrl, center, scale, geoUnit: { type, name, facilityName } } });
        }

        if (type == 'region') {
          set((state) => ({
            geoState: {
              geoUrl: country ? mapConfig.countries[country].geoUrl : state.geoState.geoUrl,
              center: mapConfig.region[name]?.center,
              scale: mapConfig.region[name]?.scale,
              geoUnit: { type, name, facilityName },
            },
          }));
        }
      },
    },
  }),
  'MapStore',
);

export const useMapActions = () => useMapStore((state) => state.actions);

export const selectMapData = () => useMapStore((state) => state.data);
export const selectMapTooltipContentStatic = () => useMapStore((state) => state.tooltipContentStatic);
export const selectMapOpenTab = () => useMapStore((state) => state.openTab);
export const selectMapOpenLegend = () => useMapStore((state) => state.openLegend);
export const selectMapGeoState = () => useMapStore((state) => state.geoState);
